import { Box, Chip, useTheme } from '@mui/material';
import { useCallback, useState } from 'react';
import { AvatarCell } from '../../../components/Table/CellRenderers/AvatarCell';
import TooltipComponent from '../../../components/TooltipComponent/TooltipComponent';
import { Typography } from '../../../components/Typography/Typography';
import { Partner } from '../../../types';

type Props = {
  deals: Partner[] | undefined;
};

const maxDealsToShow = 4;
export function DealOwnersCell({ deals }: Props) {
  const { colors } = useTheme();
  const [restDealsTooltipOpen, setRestDealsTooltipOpen] = useState(false);

  const handleRestDealsTooltipOpen = useCallback(() => {
    setRestDealsTooltipOpen(true);
  }, []);

  const handleRestDealsTooltipClose = useCallback(() => {
    setRestDealsTooltipOpen(false);
  }, []);

  const slicedDeals = deals?.slice(0, maxDealsToShow) || [];

  const restDeals = deals?.slice(maxDealsToShow, deals.length);

  const restDealsNumber = restDeals?.length;

  return (
    <Box display={'flex'} gap={1}>
      {slicedDeals.map((deal) => {
        return <AvatarCell key={deal.id} name={deal?.name || ''} />;
      })}
      {restDealsNumber ? (
        <TooltipComponent
          open={!!restDealsNumber && restDealsTooltipOpen}
          onOpen={handleRestDealsTooltipOpen}
          onClose={handleRestDealsTooltipClose}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
              }}
            >
              {restDeals?.map((item) => {
                return (
                  <Typography variant='body' color={colors.text.main} key={item.id}>
                    {item.name}
                  </Typography>
                );
              })}
            </Box>
          }
        >
          <Chip
            style={{
              backgroundColor: colors.surfaceStatus.noAction,
              minWidth: '66px',
              height: '28px',
            }}
            onClick={handleRestDealsTooltipOpen}
            label={
              <Typography variant='body' color={colors.text.main}>
                + {restDealsNumber} Deal
              </Typography>
            }
          />
        </TooltipComponent>
      ) : null}
    </Box>
  );
}
